import { fetchBidderPlaidLinkToken } from '@/redux/modules/account/payments/bankAccount/bankAccount.actions';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import {
    getPlaidError,
    getPlaidFetching,
    getPlaidLinkToken,
} from '@/redux/modules/account/payments/bankAccount/bankAccount.selectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import LaPlaidLinkLink from './LaPlaidLinkLink';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type Props = {
    useTextStyle?: boolean;
};

const LaPlaidLink = ({ useTextStyle }: Props) => {
    const dispatch = useAppDispatch();
    const bidderId = useAppSelector(getBidderId);

    const plaidLinkToken = useAppSelector((state) => getPlaidLinkToken(state, ''));
    const plaidFetching = useAppSelector(getPlaidFetching);
    const plaidError = useAppSelector(getPlaidError);

    useEffect(() => {
        if (!Boolean(plaidError) && !Boolean(plaidLinkToken) && !plaidFetching && bidderId > 0) {
            dispatch(fetchBidderPlaidLinkToken({ bidderId }));
        }
    }, [bidderId, dispatch, plaidError, plaidFetching, plaidLinkToken]);

    if (plaidFetching) {
        return (
            <StyledNotReady>
                <Throbber testid="add-bank-account-with-plaid-loading" />
            </StyledNotReady>
        );
    }

    if (plaidError) {
        return (
            <StyledNotReady>
                <FormattedMessage id="plaid.errorLoading" />
            </StyledNotReady>
        );
    }

    if (Boolean(plaidLinkToken)) {
        return (
            <LaPlaidLinkLink
                plaidLinkToken={plaidLinkToken}
                useTextStyle={useTextStyle}
            />
        );
    }

    return null;
};

export default LaPlaidLink;

const StyledNotReady = styled.div`
    display: flex;
    margin-left: 16px;
`;
